import  api, { globalErrorHandler } from "../Api"

export const GET_BANNER = "GET_BANNER";
export const GET_CONTACT = "GET_CONTACT";
export const BA_LOADING = "BA_LOADING";
export const UPDATE_BANNER = "UPDATE_BANNER";
export const ADD_CONTACT = "ADD_CONTACT";
export const DELETE_CONTACT = "DELETE_CONTACT";
export const GET_AABANNER = "GET_AABANNER";
export const GET_CHBANNER = "GET_CHBANNER";
export const AA_LOADING = "AA_LOADING";
export const CH_LOADING = "CH_LOADING";
export const BA_ERROR = "BA_ERROR";
export const CO_LOADING = "CO_LOADING";
export const CO_ERROR = "CO_ERROR";

const config = {
    headers: {
        'content-type': 'application/json',
    }
};

export const GetBanners = () => {

    return async dispatch => {
    dispatch({
        type: BA_LOADING
    });
    await api.get(`/CTAs/GetAllBanner`, config).then(res => 
        dispatch({
        type: GET_BANNER,
        data: res.data
        })
        ).catch(globalErrorHandler); 
    };
};

export const GetAskAlejandroBanner = () => {

    return async dispatch => {
    dispatch({
        type: AA_LOADING
    });
    await api.get(`/CTAs/GetAskAlejandro`,config).then(res => {
        dispatch({
        type: GET_AABANNER,
        data: res.data
        });
    }).catch(globalErrorHandler); 
    };
};

export const GetChatbotBanner = () => {

    return async dispatch => {
    dispatch({
        type: CH_LOADING
    });
    await api.get(`/CTAs/GetChatBot`,config).then(res => {
        dispatch({
        type: GET_CHBANNER,
        data: res.data
        });
        // console.log(res.data, "estamos en el action");
    }).catch(globalErrorHandler); 
    };
};

export const UpdateBanner = (payload, files, Id) => {
    var formData = new FormData();
    formData.append('Id', Id);
    formData.append('SourceURL', payload.sourceURL);
    formData.append('files', files);
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
        }
    }
    return async dispatch => {
        dispatch({
            type: BA_LOADING
        });

        api.put(`/CTAs/UpdateCTA`, 
        formData, config).then(res => {
            dispatch({
                type: UPDATE_BANNER,
                payload: res.data
            });
        })
        .catch((error) => {
            globalErrorHandler(error);
            dispatch({
            type: BA_ERROR 
            })
        });
    };
};

export const AddContact = (payload, files) => {
    var formData = new FormData();
    formData.append('Id', '0');
    formData.append('Key', "Contact");
    formData.append('SourceURL', payload.sourceURL);
    formData.append('files', files);
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
        }
    }
    return async dispatch => {
        dispatch({
            type: CO_LOADING
        });

        api.post(`/CTAs/AddContact`, 
        formData, config).then(res => {
            dispatch({
                type: ADD_CONTACT,
                payload: res.data
            });
        })
        .catch((error) => {
            globalErrorHandler(error);
            dispatch({
            type: BA_ERROR 
            })
        });
    };
};

export const GetAllContact = () => {

    return async dispatch => {
    dispatch({
        type: CO_LOADING
    });
    await api.get(`/CTAs/GetAllContact`, config).then(res => 
        dispatch({
        type: GET_CONTACT,
        data: res.data
        })
        ).catch(globalErrorHandler); 
    };
};

export const DeleteContact = (id) => dispatch => {
    dispatch({
        type: CO_LOADING
    });
    
    api.delete(`/CTAs/${id}`).then(res => {
        dispatch({
            type: DELETE_CONTACT,
            payload: res.data
        });
    })
    .catch((error) => {
        globalErrorHandler(error);
        dispatch({
        type: CO_ERROR
        })
    });
};